import { Box, merge, Text } from "theme-ui";
import camelCase from "lodash/camelCase";

import * as styles from "./Select.styles";

export function getMinWidth(s = "") {
  return Math.ceil(s.length * 7.8) + 40 + "px";
}

export default function Select({
  label,
  variant = "regular", // regular | material | round
  size = "medium", // medium | large
  sx = {},
  ...props
}) {
  const variantName = camelCase(
    ["select", variant, size].filter(Boolean).join("-")
  );

  return (
    <Box sx={styles.container}>
      {label && <Text sx={styles.label({ size })}>{label}</Text>}

      <Box
        as="select"
        variant={`forms.${variantName}`}
        sx={merge(
          styles.selectTag({ pl: label && getMinWidth(label), size }),
          sx
        )}
        {...props}
      />

      <Box
        as="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="15"
        viewBox="0 0 26 15"
        fill="none"
        sx={styles.arrow({ size })}
      >
        <path
          d="M1 1L13 13L25 1"
          stroke="currentcolor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </Box>
    </Box>
  );
}
